var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_5603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38133 1.72226C8.13162 1.47248 7.79291 1.33211 7.43971 1.33203H2.6637C2.31047 1.33203 1.97171 1.47235 1.72194 1.72212C1.47217 1.97189 1.33185 2.31065 1.33185 2.66388V7.4399C1.33192 7.7931 1.47229 8.1318 1.72208 8.38151L7.51829 14.1777C7.82096 14.4785 8.23033 14.6473 8.65702 14.6473C9.08372 14.6473 9.49308 14.4785 9.79576 14.1777L14.1775 9.79594C14.4783 9.49327 14.6471 9.0839 14.6471 8.65721C14.6471 8.23051 14.4783 7.82115 14.1775 7.51847L8.38133 1.72226Z",
    stroke: "#99A1AF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99446 5.32706C5.17835 5.32706 5.32742 5.17799 5.32742 4.9941C5.32742 4.81021 5.17835 4.66113 4.99446 4.66113C4.81057 4.66113 4.6615 4.81021 4.6615 4.9941C4.6615 5.17799 4.81057 5.32706 4.99446 5.32706Z",
    fill: "#99A1AF",
    stroke: "#99A1AF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_5603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.058526e453ff695a4cbd358b81d1d0c2.svg";
export { ForwardRef as ReactComponent };